import app from 'firebase/app';
import { executeSearchQuery } from './firestoreUtils';

const getPostCollection = () => app.firestore().collection('posts');

export const getPostByUid = uid => {
    let docRef = getPostCollection().doc(uid);
    return docRef
        .get()
        .then(function (doc) {
            if (doc.exists) {
                return doc.data();
            } else {
                console.log('No such document!');
            }
        })
        .catch(function (error) {
            console.log('Error getting document:', error);
        });
};

export const createPost = dto => {
    return new Promise(function (resolve, reject) {
        const docRef = getPostCollection().doc();
        dto.uid = docRef.id;
        docRef.set({ ...dto });
        if (docRef && docRef.id) {
            resolve(docRef.id);
        } else {
            reject('Object not created');
        }
    });
};

export const updatePost = dto => {
    return new Promise(function (resolve, reject) {
        const docRef = getPostCollection().doc(dto.uid);
        docRef.update({ ...dto });
        if (docRef && docRef.id) {
            resolve(docRef.id);
        } else {
            reject('Object not created');
        }
    });
};

export const addTotalDonation = async (id, amount) => {
    const post = await getPostByUid(id);
    return updatePost({
        ...post,
        totalDonations: post.totalDonations + amount,
    });
};

export const deletePost = uid => {
    return getPostCollection().doc(uid).delete();
};

export const getPosts = (pageSize, lastElement, approved, category, userEmail, inviteAllUsers) => {
    const query = buildSearchQuery(
        null,
        approved,
        'createdTimestamp',
        pageSize,
        lastElement,
        false,
        category,
        userEmail,
        inviteAllUsers
    );
    return executeSearchQuery(query);
};

export const getUserPosts = (pageSize, lastElement, publisherUid, approved, category) => {
    const query = buildSearchQuery(
        publisherUid,
        approved,
        'createdTimestamp',
        pageSize,
        lastElement,
        false,
        category
    );
    return executeSearchQuery(query);
};

const _updatePostReadStatus = (postId, status) => {
    return getPostCollection().doc(postId).set({ hasUpdates: status }, { merge: true });
};

export const markPostAsRead = id => {
    return _updatePostReadStatus(id, false);
};

export const markPostAsUnread = id => {
    return _updatePostReadStatus(id, true);
};

export const getPendingPostsCount = () => {
    return getPostCollection()
        .where('isApprovedByAdmin', '==', false)
        .where('isDeleted', '==', false)
        .get()
        .then(snap => snap.size);
};

export const getInvitationsPostCount = async (userId, userEmail) => {
    const [myInvitations, forAllUsersCount] = await Promise.all([
        getPostCollection()
            .where('inviteColleagues', 'array-contains', userEmail)
            .get()
            .then(snap => snap.size),
        getPostCollection()
            .where('inviteAllUsers', '==', true)
            .where('isApprovedByAdmin', '==', true)
            .where('isDeleted', '==', false)
            .get()
            .then(
                snap => snap.docs.filter(article => article.data().publisherUid !== userId).length
            ),
    ]);

    return myInvitations + forAllUsersCount;
};

export const getUnreadMyPostIds = async userId => {
    return getPostCollection()
        .where('isApprovedByAdmin', '==', true)
        .where('isDeleted', '==', false)
        .where('isClosed', '==', false)
        .where('publisherUid', '==', userId)
        .where('hasUpdates', '==', true)
        .get()
        .then(snap => snap.docs.map(d => d.id));
};

export const closePost = async postId => {
    return getPostCollection().doc(postId).set({ isClosed: true });
};

const buildSearchQuery = (
    publisherUid,
    approved,
    orderBy,
    pageSize,
    lastElement,
    deleted,
    category,
    userEmail,
    inviteAllUsers
) => {
    let query = getPostCollection();
    query.where('isClosed', '==', false);
    if (orderBy) {
        query = query.orderBy(orderBy, 'desc');
    }
    if (publisherUid) {
        query = query.where('publisherUid', '==', publisherUid);
    }
    if (approved || approved === false) {
        query = query.where('isApprovedByAdmin', '==', approved);
    }
    if (deleted || deleted === false) {
        query = query.where('isDeleted', '==', deleted);
    }
    if (category) {
        query = query.where('category', '==', category.uid);
    }
    if (userEmail) {
        query = query.where('inviteColleagues', 'array-contains', userEmail);
    }
    if (inviteAllUsers) {
        query = query.where('inviteAllUsers', '==', inviteAllUsers);
    }
    if (pageSize) {
        query = query.limit(pageSize);
    }
    if (lastElement) {
        query = query.startAfter(lastElement);
    }
    return query;
};
